export enum NavAction {
  Auth = 'auth',
}
